import React, { useEffect, useId, useState } from 'react';
import PropTypes from 'prop-types';
import Loading from '../utilities/Loading';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormElementHeader from "./FormElementHeader";
import HelpDialog from "../dialog/HelpDialog";
import DropDown from "./DropDown";

const fetchContentTypes = async () => {
  const URL = `${process.env.REACT_APP_LATAAMO_PROXY_SERVER}/api/content-types`;
  try {
    const response = await fetch(URL);
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Unexpected status code from ${URL}`, {
      cause: { status: response.status }
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const ContentTypes = ({
                        selected,
                        onChange,
                        disabled,
                        message,
                        afterHeader,
                        required,
                        defaultOptionLabelKey,
                      }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [contentTypes, setContentTypes] = useState(null);

  const id = useId();

  useEffect(() => {
    if (!contentTypes) {
      (async () => {
        setContentTypes([...(await fetchContentTypes())]);
        setLoading(false);
      })();
    }
  }, [loading, contentTypes]);

  return (
      <Loading loading={loading}>
        <Container className="content-types-container">
          <Row>
            <Col>
              <FormElementHeader
                  id={id}
                  helpDialog={(
                      <HelpDialog label={t('content_type_help_label')}>
                        {t('content_type_help_content')}
                      </HelpDialog>
                  )}
                  required={required}
              >
                {t('content_type_header')}
              </FormElementHeader>
            </Col>
          </Row>

          {afterHeader && (
              <Row>
                <Col>
                  {afterHeader}
                </Col>
              </Row>
          )}

            <Row>
                <Col>
                    <DropDown
                        aria-labelledby={id}
                        aria-required="true"
                        options={
                            [
                                { label: t(defaultOptionLabelKey), value: '' },
                                ...(contentTypes
                                    ?.map(ct => {
                                        const raw = ct ?? '';
                                        const keySuffix = String(raw)
                                            .toLowerCase()
                                            .trim()
                                            .replace(/\s+/g, '_');

                                        return {
                                            label: t(`content_type_${keySuffix}`),
                                            value: ct,
                                        };
                                    })
                                    ?.sort((a, b) => a.label.localeCompare(b.label))) || []
                            ]
                        }
                        value={selected}
                        message={message}
                        disabled={disabled}
                        onChange={e => onChange(e.target.value)}
                    />
                </Col>
            </Row>
        </Container>
      </Loading>
  );
};

ContentTypes.propTypes = {
  selected: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  message: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf(['light', 'neutral', 'warning'])
  }),
  afterHeader: PropTypes.node,
  defaultOptionLabelKey: PropTypes.string.isRequired,
};

export default ContentTypes;
